import { useLocation } from 'react-router-dom'

/**
 * Хук для получения query-параметра из URL.
 * @param paramName - Имя параметра, который нужно получить.
 * @returns Значение параметра или undefined, если параметр не найден.
 */
export const useQueryParam = (paramName: string): string | undefined => {
	const location = useLocation()
	const queryParams = new URLSearchParams(location.search)
	return queryParams.get(paramName) || undefined
}
